import { z } from "zod";
import { resetPasswordPayloadSchema } from "@features/account/model/payload/resetPassword.payload";

export const resetPasswordFormSchema = resetPasswordPayloadSchema
  .extend({
    passwordCheck: z.string().nonempty("새비밀번호를 입력해 주세요."),
  })
  .refine((data) => data.password === data.passwordCheck, {
    path: ["passwordCheck"],
    message: "비밀번호가 일치하지 않습니다.",
  });

export type ResetPasswordFormType = z.infer<typeof resetPasswordFormSchema>;
